<template>
	<el-row>
		<el-form>
			<el-form-item>
				<el-cascader @change="getimgList($event)" v-model="ClassificationName" :options="Classification"
					:props="classProps">
				</el-cascader>
			</el-form-item>
			<el-form-item>
				<div class="imgBox">
					<div class="imgItem" v-for="(item, index) in imgList" :key="index">
						<el-image fit="fit" :src="item.imgUrl+'?x-oss-process=image/resize,w_50'"></el-image>
						<el-checkbox @change="changImg(item, index)" v-model="item.isShow" />
					</div>
				</div>
			</el-form-item>
			<el-form-item v-if="imgList.length > 0">
				<el-button @click="sumbit()">
					确认
				</el-button>
			</el-form-item>
		</el-form>
	</el-row>
</template>

<script>
	export default {
		props: {
			imgNum: {
				type: Number,
				default: null,
			}
		},
		data() {
			return {
				Classification: [],
				ClassificationName: '',
				imgList: [],
				classProps: {
					label: 'name',
					value: 'id',
					children: 'children',
				},
				list: []
			}
		},
		methods: {
			sumbit() {
				if (this.list.length == 0) {
					this.$message.error('请先选择图片')
					return false
				}
				this.$emit('imgList', this.list);
				this.dialogFormVisible = false
			},
			changImg(item, index) {
				var list = []
				if (this.imgNum > 1) {
					this.imgList.forEach(item => {
						if (item.isShow) {
							if (list.length < 9) {
								item.isShow = true
								list.push(item.imgUrl)
							} else {
								item.isShow = false
								this.$message.error('选择数量已到达上限')
							}
						}
					})
				} else {
					this.imgList.forEach((item, index2) => {
						item.isShow = false
						if (index == index2) {
							item.isShow = true
							list.push(item.imgUrl)
						}
					})

				}
				console.log(list.join(','));
				this.list = list.join(',')
			},
			getimgList(e) {
				console.log(e[2]);
				var id = e[2]
				this.imgList = []
				this.$http.get(`/api/material/categories/material/all?categoryId=` + id, {}).then(res => {
					console.info("loadData", res.data)
					if (res.data.length > 0) {
						res.data.forEach(item => {
							item.isShow = false
							if (item.imgUrl.substring(item.imgUrl.length - 4) == ".mp4") {
								item.urlType = 2
							} else {
								item.urlType = 1
							}
							this.imgList.push({
								imgId: item.imgId,
								imgUrl: item.imgUrl,
								isShow: item.false,
								urlType: item.urlType
							})
						})
					}
				})
			},
			getClass() {
				this.$http.get('/api/material/categories/0', {}).then(res => {
					let data = res.data.children
					if (data.length > 0) {
						data.forEach(item => {
							item.children.forEach(item2 => {
								item2.children.forEach(item3 => {
									item3.children = null
								})
							})
						})
					}
					this.Classification = res.data.children
					console.info("类目", res.data.children)
				})
			},
			openImg(val) {
				console.log(val);
				this.myString = val;
			}

		},
		mounted() {
			this.getClass()
		}
	}
</script>

<style lang="less" scoped>
	.el-form {
		width: 100%;
	}

	.el-cascader {
		width: 500px !important;
	}

	.imgBox {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.imgItem {
			width: 100px;
			height: 100px;
			position: relative;
			margin-right: 10px;
			margin-top: 10px;

			.el-image {
				width: 100%;
				height: 100%;
			}

			.el-checkbox {
				position: absolute;
				right: 0;
				top: -10px;
			}
		}
	}
</style>
